<template>
  <div class="ats-req-id">
    <DpplTooltip
      tooltip-placement="left"
      :tooltip-offset="12"
    >
      <template #activator="{ onMouseenter, onMouseleave }">
        <div
          v-if="reqUuid"
          class="d-flex align-center"
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          <router-link
            :to="{ name: 'requisition-report', params: { id: reqUuid } }"
            target="_blank"
            rel="noopener noreferrer"
            class="reqid-link"
            @click.stop="emits('library-req-report-track')"
          >
            <IconOpen class="mr-1" />
            <span>
              {{ isAtsReqIdMultiple ? 'Multiple Req IDs' : atsReqId || 'Req Report' }}
            </span>
          </router-link>
        </div>
        <p
          v-else
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
        >
          {{ isAtsReqIdMultiple ? 'Multiple Req IDs' : (atsReqId || flexibleId) }}
        </p>
      </template>
      <template #tooltip-content>
        <p class="content">
          {{
            reqUuid
              ? 'View Req Progress Report'
              : (atsReqId || flexibleId || '')
          }}
        </p>
      </template>
    </DpplTooltip>
  </div>
</template>

<script setup>
import DpplTooltip from '@/components/datapeople/DpplTooltip.vue';
import { computed } from 'vue';
import IconOpen from '@/assets/icon_open.svg?component';

const props = defineProps({
  reqUuid: {
    type: String,
    default: '',
  },
  atsReqId: {
    type: String,
    default: '',
  },
  flexibleId: {
    type: String,
    default: '',
  },
});

const emits = defineEmits(['library-req-report-track']);

const isAtsReqIdMultiple = computed(() => {
  if (props.atsReqId?.split(', ')?.length) {
    return props.atsReqId.split(', ').length > 1;
  }

  return false;
});
</script>

<style lang="less" scoped>
.ats-req-id {
  max-width: 100%;
  overflow: hidden;

  :deep(p) {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 500;
    font-size: 13px;
    color: @text-light;

    &.content {
      line-height: 150%;
      color: @text-light;
      overflow: visible;
      white-space: normal;
    }
  }

  :deep(.reqid-link) {
    font-size: 13px;
    color: @text-brand;

    &:visited {
      color: @text-brand;
    }
  }
}
</style>
